import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import TransactionTable from "../../elements/Tables/TransactionTable/TransactionTable";
// import TransactionCreationForm from "../../elements/Forms/TransactionCreationForm/TransactionCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_TRANSACTION_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteTransaction } from "../../../Services/TransactionService";

const { Search } = Input;

const TransactionPageSPG = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transactionId, setTransactionId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setTransactionId(id);
    setIsModalOpen(true);
  };

  const handleCreate = async () => {
    history.push("/user/create-transaction");
  };

  const handleOk = async () => {
    try {
      await deleteTransaction(transactionId);
      message.success("Transaction deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete transaction."
      );
    }
    setIsModalOpen(false);
  };

  const { fetchedData, callReFetch, loading } = useFetch(
    `${FETCH_ALL_TRANSACTION_API}/article`,
    state
  );

  // Extract data from the response
  const data = fetchedData?.data?.data || [];

  const handleSearch = (value) => {
    if (state.searchKeyword !== value) {
      dispatch({ type: "searchKeyword", payload: value });
      callReFetch();
    }
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "80vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleCreate}>
          Create New Transaction
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <TransactionTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Delete Transaction"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this transaction?</p>
      </Modal>
    </div>
  );
};

TransactionPageSPG.propTypes = {};

export default TransactionPageSPG;
